var SubmissionState;
(function (SubmissionState) {
    SubmissionState[SubmissionState["INITIAL"] = 0] = "INITIAL";
    SubmissionState[SubmissionState["LOADING"] = 1] = "LOADING";
    SubmissionState[SubmissionState["SUCCESS"] = 2] = "SUCCESS";
    SubmissionState[SubmissionState["ERROR"] = 3] = "ERROR";
})(SubmissionState || (SubmissionState = {}));
export default SubmissionState;
